import $ from 'jquery'

export default {

    bind: function(el, binding) {
        let url = `http://${window.location.host}/faq`;
        setTimeout(() => {
            new STDFAQ({
                element: '#message',
                customWrapperId: 'stdfaq-form',
                platformId: 969,
                pathToFaq: url,
                limit: 5
            });
            setTimeout(() => {
                let event = new Event('keyup');
                document.getElementById('message').dispatchEvent(event);
            }, 10);
        }, 100);
    }

}